var map = {
	"./365-pay.svg": "UrzF",
	"./404.svg": "meGU",
	"./DiagnosisStatistics.svg": "kOKf",
	"./Doctor2DiagnosisStatisticsConsilia.svg": "dqOB",
	"./Doctor2DiagnosisStatisticsConsilia_active.svg": "I9ZC",
	"./Doctor2DiagnosisStatisticsOverview.svg": "FGJ2",
	"./Doctor2DiagnosisStatisticsOverview_active.svg": "zdUn",
	"./Doctor2PrescriptionMedicineStatistics.svg": "e38Y",
	"./Doctor2PrescriptionMedicineStatistics_active.svg": "kuAe",
	"./Doctor2PrescriptionStatistics.svg": "EZOH",
	"./Doctor2PrescriptionStatistics_active.svg": "8xjw",
	"./Doctor2StatisticsConclusion.svg": "tePs",
	"./Doctor2StatisticsConclusion_active.svg": "hmnK",
	"./Doctor2StatisticsDisease.svg": "glG+",
	"./Doctor2StatisticsDisease_active.svg": "LKl5",
	"./add.svg": "TuMq",
	"./ai-diagnosis.svg": "rOVj",
	"./ai.svg": "QdpP",
	"./apiRecord.svg": "ECT8",
	"./appointment_board.svg": "WOmi",
	"./appointment_board_active.svg": "flHa",
	"./avatarUpload.svg": "L+Td",
	"./avatar_boy.svg": "UAVM",
	"./avatar_default.svg": "y5Yu",
	"./avatar_girl.svg": "wxdR",
	"./back-to-top.svg": "OjpM",
	"./batch-delete.svg": "RUTv",
	"./bug.svg": "Omjj",
	"./chart.svg": "42h+",
	"./check.svg": "DLDc",
	"./checkFail.svg": "dLlC",
	"./check_selected.svg": "MAPD",
	"./check_unselected.svg": "XFfb",
	"./clipboard.svg": "fDub",
	"./collapse.svg": "Sv15",
	"./collect.svg": "Tw70",
	"./component.svg": "QhzR",
	"./cooperation.svg": "2Mqk",
	"./corp.svg": "+tkt",
	"./countTo.svg": "BTNa",
	"./dashboard.svg": "9ya6",
	"./delete-blue.svg": "vUql",
	"./delete-red.svg": "pIs1",
	"./delete.svg": "NUrT",
	"./diagnosis-ai.svg": "GTyu",
	"./diagnosis-chinese-medicine.svg": "9L/W",
	"./diagnosis-online-camera.svg": "6om9",
	"./diagnosis-select-file.svg": "+YBX",
	"./diagnosis-symptom.svg": "kxAv",
	"./diagnosis-tcm-medicine.svg": "SGF6",
	"./diagnosis-western-medicine.svg": "LifJ",
	"./doctor-info.svg": "r+24",
	"./doctor-inquiry.svg": "zZ1r",
	"./doctor-record-list.svg": "Xk7j",
	"./doctor.svg": "BajG",
	"./doctor2_diagnosis-enter-disease-erke.svg": "9pjX",
	"./doctor2_diagnosis-enter-disease-huxi.svg": "EF48",
	"./doctor2_diagnosis-enter-disease-jingshen.svg": "NE7h",
	"./doctor2_diagnosis-enter-disease-mianyi.svg": "9o71",
	"./doctor2_diagnosis-enter-disease-miniao.svg": "9JOa",
	"./doctor2_diagnosis-enter-disease-neifenmi.svg": "bP48",
	"./doctor2_diagnosis-enter-disease-pifu.svg": "PPUk",
	"./doctor2_diagnosis-enter-disease-shengzhi.svg": "0w8z",
	"./doctor2_diagnosis-enter-disease-shenjing.svg": "Hp+U",
	"./doctor2_diagnosis-enter-disease-wuguan.svg": "dVkF",
	"./doctor2_diagnosis-enter-disease-xiaohua.svg": "zy3N",
	"./doctor2_diagnosis-enter-disease-xunhuan.svg": "OgWp",
	"./doctor2_diagnosis-enter-disease-yundong.svg": "35hT",
	"./doctor2_diagnosis-switch-chinese.svg": "lhHR",
	"./doctor2_diagnosis-switch-chinese2.svg": "ScJL",
	"./doctor2_diagnosis-switch-western.svg": "xJeF",
	"./doctor2_diagnosis-switch-western2.svg": "ZCTh",
	"./doctor2_diagnosis_medicine.svg": "X36e",
	"./doctor2_diagnosis_symptom.svg": "br9m",
	"./doctor2_huayi.svg": "z52d",
	"./doctor2_knowledge_base.svg": "b9xT",
	"./doctor2_knowledge_classic_medical_cases.svg": "fvLR",
	"./doctor2_knowledge_classic_medical_cases_active.svg": "4tIr",
	"./doctor2_knowledge_clinical-pathway.svg": "vsDt",
	"./doctor2_knowledge_clinical-pathway_active.svg": "DfPZ",
	"./doctor2_knowledge_formula.svg": "XEef",
	"./doctor2_knowledge_formula_active.svg": "sdjm",
	"./doctor2_knowledge_medicinal_material.svg": "BA+q",
	"./doctor2_knowledge_medicinal_material_active.svg": "ROuo",
	"./doctor2_knowledge_modern_medical_data.svg": "FFWq",
	"./doctor2_knowledge_modern_medical_data_active.svg": "lzOV",
	"./doctor2_manage_charge.svg": "lL2q",
	"./doctor2_manage_charge_active.svg": "qKnX",
	"./doctor2_manage_delivery.svg": "NsQx",
	"./doctor2_manage_delivery_active.svg": "wOXP",
	"./doctor2_manage_follow.svg": "3nq6",
	"./doctor2_manage_follow_active.svg": "UyMv",
	"./doctor2_manage_member.svg": "riJ+",
	"./doctor2_manage_member_active.svg": "F9GO",
	"./doctor2_manage_patient.svg": "m1IQ",
	"./doctor2_manage_patient_active.svg": "ejw1",
	"./doctor2_manage_record.svg": "Sb5l",
	"./doctor2_manage_record_active.svg": "eAFS",
	"./doctor2_manage_stock.svg": "WN0B",
	"./doctor2_manage_stock_active.svg": "KWbo",
	"./doctor2_manage_temple.svg": "KhFK",
	"./doctor2_manage_temple_active.svg": "tb1j",
	"./doctor2_manage_treat.svg": "2p5q",
	"./doctor2_manage_treat_active.svg": "ftXL",
	"./doctor2_record_list.svg": "r98E",
	"./doctor2_stock.svg": "QEnA",
	"./documentation.svg": "QUl8",
	"./drag.svg": "pUq1",
	"./edit.svg": "CMb/",
	"./email.svg": "ULWC",
	"./example.svg": "EL2D",
	"./excel.svg": "sWjn",
	"./eye.svg": "ekvI",
	"./follow-state-0.svg": "FdyH",
	"./follow-state-1.svg": "hZBA",
	"./follow-state-2.svg": "502F",
	"./form.svg": "qfxb",
	"./fzzl-yellow.svg": "ow4g",
	"./fzzl.svg": "Gse4",
	"./guide.svg": "Smtd",
	"./home.svg": "vIvP",
	"./huayi-tcm-icon.svg": "svk3",
	"./icon.svg": "OpEq",
	"./international.svg": "VUt5",
	"./key.svg": "3yDL",
	"./klj-yellow.svg": "SqLd",
	"./klj.svg": "bGmB",
	"./language.svg": "8Lz/",
	"./link.svg": "sAHT",
	"./list.svg": "8MU1",
	"./loading.svg": "uWoO",
	"./lock.svg": "r7Co",
	"./lyrk.svg": "YQq9",
	"./manual-update-tongue-face-from-other-record.svg": "TYLZ",
	"./manual-upload-tongue-face-image.svg": "CBQT",
	"./medical-record.svg": "3R7b",
	"./medicine-knowledge-info.svg": "M4Pt",
	"./medicine-knowledge-medical.svg": "ygLA",
	"./medicine-knowledge-path.svg": "MCP1",
	"./medicine-knowledge-prescription.svg": "o9A0",
	"./medicine-knowledge-rec-prescription.svg": "soKL",
	"./member-archives-icon.svg": "6eMu",
	"./member-info.svg": "3Q/4",
	"./member-records.svg": "JsxH",
	"./member.svg": "BtLH",
	"./memberUser.svg": "WHMv",
	"./member_tag.svg": "nq73",
	"./menu-api-app.svg": "7ell",
	"./menu-cost-center.svg": "3WnF",
	"./menu-h5-app.svg": "8m7u",
	"./menu-weixin-app.svg": "yCpm",
	"./menu-zhanghao.svg": "jkCP",
	"./message.svg": "St3G",
	"./money.svg": "NGFH",
	"./nested.svg": "b7U3",
	"./order-canceled.svg": "e4EH",
	"./order-closed.svg": "WiaF",
	"./order-paid.svg": "+M3i",
	"./password.svg": "Jtj/",
	"./pay-alipay.svg": "O3F/",
	"./pay-cash.svg": "a09+",
	"./pay-wallet.svg": "qCPu",
	"./pay-wechat.svg": "e5AY",
	"./payAmount.svg": "5snl",
	"./payNum.svg": "W7X4",
	"./people.svg": "G8xD",
	"./peoples.svg": "eh5m",
	"./prescription-selected.svg": "ikui",
	"./prescription-unselected.svg": "MOQy",
	"./prescription.svg": "BzLY",
	"./qq.svg": "g3MA",
	"./qrcode.svg": "bf2g",
	"./question-mark.svg": "1pPq",
	"./question.svg": "fT+F",
	"./review_user.svg": "saOm",
	"./rewardAmount.svg": "pL2r",
	"./rewardNum.svg": "m7M+",
	"./right-header-cost-chongzhi.svg": "1Rsc",
	"./right-header-cost-feiyong.svg": "iCrQ",
	"./right-header-cost-xiaofei.svg": "9/80",
	"./right-header-default-avatar.svg": "bSk8",
	"./right-header-logout.svg": "f2T6",
	"./right-header-qiyerenzheng.svg": "QhEj",
	"./right-header-yonghuguanli.svg": "5H29",
	"./right-header-zhanghaoxinxi.svg": "TUkR",
	"./screenFull.svg": "kdnQ",
	"./shoppingCard.svg": "KCQB",
	"./show.svg": "pFXn",
	"./size.svg": "Xj+I",
	"./skill-fh.svg": "wD2Q",
	"./skill-fhp.svg": "MBSI",
	"./skill-xaxp.svg": "gXnU",
	"./split-panel.svg": "cqM4",
	"./star.svg": "kI1z",
	"./sticky.svg": "6woY",
	"./success.svg": "cQmE",
	"./system.svg": "SlHp",
	"./tab.svg": "5zN1",
	"./table.svg": "jF5L",
	"./tcm-chat-icon-bzlz.svg": "9Qr+",
	"./tcm-chat-icon-jktl.svg": "2t5E",
	"./tcm-chat-icon-shljf.svg": "p0/7",
	"./tcm-chat-icon-tszb.svg": "ehld",
	"./tcm-chat-icon-zyyf.svg": "LsoS",
	"./tcm-chat-icon-zyzs.svg": "zehE",
	"./tcm-chat-inquiry-answer-selected.svg": "QerD",
	"./tcm-chat-inquiry-answer-unselect.svg": "He+f",
	"./tcm_model_user_input_stop.svg": "fUuX",
	"./team.svg": "AWrz",
	"./teamApply.svg": "lZB5",
	"./theme.svg": "wXqr",
	"./tinymce.svg": "t673",
	"./to_be_opened.svg": "74tR",
	"./treeSelect.svg": "yvNK",
	"./user.svg": "fP5l",
	"./warning.svg": "Mk8d",
	"./wechat.svg": "8do1",
	"./weixin.svg": "dcqJ",
	"./zcycf-yellow.svg": "7bDd",
	"./zcycf.svg": "djVh",
	"./zip.svg": "kNsC",
	"./zyyp-yellow.svg": "MwRs",
	"./zyyp.svg": "FUJm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2tc1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg nonrecursive \.svg$
// module id = 2tc1
// module chunks = 10